import { render, staticRenderFns } from "./VolunteergiftsRecord.vue?vue&type=template&id=21bff767&scoped=true"
import script from "./VolunteergiftsRecord.vue?vue&type=script&lang=js"
export * from "./VolunteergiftsRecord.vue?vue&type=script&lang=js"
import style0 from "./VolunteergiftsRecord.vue?vue&type=style&index=0&id=21bff767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff767",
  null
  
)

export default component.exports